var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-transitions background-login",staticStyle:{"background-color":"#e3e3e3","background-image":"url(img/misc/trama.jpg)","background-size":"auto !important"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }